import {Component} from '@angular/core';

@Component({
    selector: 'tfl-check-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
                <path d="M0 0h24v24H0z"/>
                <path fill="#009688" d="M10.364 14.877l-4.773-4.685L4 11.754 10.364 18 21 7.562 19.409 6z"/>
            </g>
        </svg>
    `
})
export class CheckIcon {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/check.icon.ts